<template>
    <calendar
            :ajax-url="ajaxUrl"
            date-key="start"
            @daySelected="setDate"
            ref="calendar"
            class="d-flex justify-content-center"
            initialDate="initialDate"
    ></calendar>
</template>

<script>
    export default {
        props: ['initialDate','filter_events_route'],
        name: "BatchesCalendar",
        methods: {
            setDate (message) {
                this.$emit('setDate', message);
            },
        }
    }
</script>

<style scoped>

</style>